import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// globals.css defines the .input/.label/.card/.btn-secondary/.badge-*/.table component
// classes that most pages (and the shared SlidePanel/FormField/Badge components) rely on
// — it was never imported anywhere, so those classes silently resolved to nothing and
// every form input/label/card across the app rendered unstyled.
import './styles/globals.css';
import './i18n';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode><App /></React.StrictMode>);
